/* Copyright (c) 2020-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import styled, { css } from "styled-components";
import { Button, FlexContainer, theme, Tooltip } from "@nordcloud/gnui";
import { Provider } from "~/generated/graphql";

type Props = {
  value: Provider[];
  onSelect: (provider: Provider) => void;
};

const ProviderButton = styled(Button)`
  border-color: ${theme.color.border.input};
  filter: grayscale(100%);

  ${({ value: selected }) =>
    selected &&
    css`
      border-color: ${theme.color.border.focus};
      filter: none;
    `}

  transition: ${theme.transition};
  margin-right: ${theme.spacing.spacing02};
`;

export function ProviderMultiSelect({ value, onSelect: onChange }: Props) {
  return (
    <FlexContainer justifyContent="flex-start">
      <Tooltip caption="AWS">
        <ProviderButton
          icon="aws"
          value={value?.find((provider) => provider === Provider.Aws)}
          severity="medium"
          onClick={() => onChange(Provider.Aws)}
        />
      </Tooltip>
      <Tooltip caption="Google Cloud">
        <ProviderButton
          icon="gcp"
          value={value?.find((provider) => provider === Provider.Gcp)}
          severity="medium"
          onClick={() => onChange(Provider.Gcp)}
        />
      </Tooltip>
      <Tooltip caption="AZURE">
        <ProviderButton
          icon="azure"
          value={value?.find((provider) => provider === Provider.Azure)}
          severity="medium"
          onClick={() => onChange(Provider.Azure)}
        />
      </Tooltip>
      <Tooltip caption="IBMCLOUD">
        <ProviderButton
          icon="ibmCloud"
          value={value?.find((provider) => provider === Provider.Ibmcloud)}
          severity="medium"
          onClick={() => onChange(Provider.Ibmcloud)}
        />
      </Tooltip>
      <Tooltip caption="VMWARE">
        <ProviderButton
          icon="vmware"
          value={value?.find((provider) => provider === Provider.Vmware)}
          severity="medium"
          onClick={() => onChange(Provider.Vmware)}
        />
      </Tooltip>
      <Tooltip caption="Kubernetes">
        <ProviderButton
          icon="kubernetes"
          value={value?.find((provider) => provider === Provider.Kubernetes)}
          severity="medium"
          onClick={() => onChange(Provider.Kubernetes)}
        />
      </Tooltip>
      <Tooltip caption="Openshift">
        <ProviderButton
          icon="openshift"
          value={value?.find((provider) => provider === Provider.Openshift)}
          severity="medium"
          onClick={() => onChange(Provider.Openshift)}
        />
      </Tooltip>
    </FlexContainer>
  );
}
